// import "babel-polyfill";
// require('es6-promise').polyfill()
// let VConsole = require('../node_modules/vconsole/dist/vconsole.min');
// let vConsole = new VConsole();
// Vue.use(vConsole);
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import vConsole from '@/modules/vconsole.js'

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)   //引入粘贴板

import axios from 'axios';
Vue.prototype.$axios = axios;
// axios.defaults.baseURL = '/api'  // 改成/api才能用proxyTable跨域

import vueCookie from 'vue-cookies'
Vue.use(vueCookie)


import qs from "qs"
Vue.prototype.$qs = qs;

//import VueResource from 'vue-resource'
//Vue.use(VueResource)


Vue.config.productionTip = false

import "@/stylesheets/main.scss"     //引入main.scss
import "@/modules/rem.js"        //适配机型



import Bridge from "@/modules/bridge.js"
Vue.prototype.$bridge = Bridge;

import {InfiniteScroll , Loadmore } from 'mint-ui';
Vue.use(InfiniteScroll);
Vue.component("mt-loadmore", Loadmore);



new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
